// extracted by mini-css-extract-plugin
module.exports = {"dashboardFormsWrapper":"__dashboardFormsWrapper___2_WFI","drawerHeader":"__drawerHeader___255mW"};